import React, { forwardRef } from 'react';
import { classnames } from '@bem-react/classnames';
export const YfmHtml = forwardRef(function YfmHtml(props, ref) {
    const { html, linksVisited, noListReset, className, qa } = props;
    return (React.createElement("div", { ref: ref, dangerouslySetInnerHTML: { __html: html }, className: classnames('yfm', linksVisited ? 'yfm_links-visited' : undefined, noListReset ? 'yfm_no-list-reset' : undefined, className), "data-qa": qa }));
});
